import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Container,
  Divider,
  Link,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  link: {
    color:
      theme.palette.type === "dark"
        ? theme.palette.secondary.main
        : theme.palette.primary.main
  }
}));

const About = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card>
        <CardHeader
          title={
            <>
              The <s>Everything</s>Most of The Things FAQ
            </>
          }
        />
        <Divider />
        <CardContent>
          <Typography component="p" variant="h6" gutterBottom>
            Who's responsible for this?!
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            Greetings! I'm Chris and I wrote this app. I'm a front-end software
            engineer and sci-fi/fantasy author. If you like genre-blending
            adventures,{" "}
            <Link
              className={classes.link}
              href="https://www.chriswsh.com/stories"
            >
              check out my stories
            </Link>{" "}
            or{" "}
            <Link
              className={classes.link}
              href="https://www.chriswsh.com/freebook"
            >
              sign up for my author newsletter
            </Link>
            .
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            The app is &copy; 2020 or later.
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            Why do the dice move so $%^&amp; slow?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            Rendering the dice in 3-D can be too much for older processors. If
            you're having issues, try{" "}
            <Link
              className={classes.link}
              href="https://www.computerhope.com/issues/ch002154.htm"
            >
              enabling hardware acceleration
            </Link>
            .
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            (The link is provided for informational purposes only, and is
            provided "as is" without warranty of any kind. OGN also doesn't
            endorse/support any content or other services provided by any linked
            websites.)
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            How can I complain about other things?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            If you want to report a bug or request a feature, please go to the{" "}
            <Link
              className={classes.link}
              href="https://forum.opengamingnetwork.com/"
            >
              OGN forum
            </Link>
            . I can help with the app, but for retcon-induced childhood
            ruination you'll probably want to{" "}
            <Link
              className={classes.link}
              href="https://www.change.org/start-a-petition"
            >
              start a petition
            </Link>
            .
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            Why isn't this free?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            It takes time and money to write software, not to mention organizing
            the years of gaming information John's collected&mdash;no interns
            were harmed in the making of this app. I'm getting a portion of the
            subscription payments, and if you like this app, the best way to
            support getting more is to subscribe!
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            Why isn't this open source?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            OGN and I both believe in open source. I've contributed to{" "}
            <Link
              className={classes.link}
              href="https://github.com/jpodwys/superagent-cache"
            >
              superagent-cache
            </Link>
            , which is only interesting to web developers, as well as to a
            text-message reminder system for upcoming court dates. The police
            don't always enjoy a rousing game of hide-and-seek, and forgetting
            to pay a fine can result in more fines. Not fun.
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            However, because the rainbow unicorn that rules my dreams with a
            glittery hoof&mdash;tough but fabulous&mdash;is beyond such petty
            human concepts as money, this code isn't open source yet.
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            When will this be open source?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            I'm considering making the dice box an open source module for use
            with{" "}
            <Link className={classes.link} href="https://reactjs.org/">
              React
            </Link>
            , available via{" "}
            <Link className={classes.link} href="https://www.npmjs.com/">
              npm
            </Link>
            . However, that also takes time and due to the licensing arragment
            between me and OGN, that's something we'll need to discuss.
          </Typography>
          <Typography component="p" variant="h6" gutterBottom>
            Did you make this all yourself?
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            Of course not.
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            The dice box is a functional programming refactor of the{" "}
            <Link className={classes.link} href="http://a.teall.info/dice/">
              Teal 3-D Dice Roller
            </Link>{" "}
            by{" "}
            <Link className={classes.link} href="http://a.teall.info/">
              Anton Natarov
            </Link>
            . Thanks for making it open source! Recreating the geometry and ray
            tracing would have been&hellip;painful.
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            The UI was composed from{" "}
            <Link className={classes.link} href="https://material-ui.com/">
              Material UI
            </Link>
            , and the guts include{" "}
            <Link className={classes.link} href="https://redux.js.org/">
              Redux
            </Link>{" "}
            and{" "}
            <Link
              className={classes.link}
              href="https://folktale.origamitower.com/"
            >
              Folktale
            </Link>
            .
          </Typography>
          <Typography component="p" variant="body1" gutterBottom>
            And not to mention the work of Matt Thomason and other assorted
            sysadmins/back-end digital dwarves for building out the
            infrastructure so I didn't have to.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default About;
